module.exports = __webpack_public_path__ + "static/media/ic-plus-blue.07468df5.svg";